import { v4 as uuidv4 } from 'uuid';
import { MapStyle } from './MapStyle.js';
import { coordinateUtils } from '../utils/coordinateUtils.js';

export class Shop {
    constructor({
        id = uuidv4(),
        name,
        location = '',
        // Normalize websites (handle legacy 'website' string or 'websites' array)
        websites = [],
        website = null,
        coordinates = null,
        subscribed_to_shopids = [],
        type = 'operator',
        // New explicit props mapping
        logo_url = null,
        logoUrl = null, // Handle both cases
        style = null,
        calibration = {},
        status = 'active',
        mass_invite_token = null, // [NEW] Mass Invite Token
        public_embed_token = null,
        venmo_handle = null,
        allow_personal_tips = false,
        tipping_enabled = true
    }) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.status = status ? status.toLowerCase() : 'active';
        this.location = location;
        this.coordinates = coordinateUtils.parseCoordinates(coordinates);

        // Handle dual source for websites
        if (websites && websites.length > 0) {
            this.websites = websites;
        } else if (website) {
            this.websites = website.split(',').map(s => s.trim());
        } else {
            this.websites = [];
        }

        this.subscribed_to_shopids = subscribed_to_shopids;

        // Branding
        this.logoUrl = logoUrl || logo_url;

        // Map Styling (For Widget/Embed)
        // Single source of truth. Default to Standard if missing.
        this.style = style || MapStyle.getDefault().url;

        // Map Calibration (Hero Shot)
        this.calibration = {
            zoom: 10,
            pitch: 0,
            bearing: 0,
            ...calibration // Spread the passed object
        };

        this.massInviteToken = mass_invite_token;
        this.publicEmbedToken = public_embed_token;
        this.venmo_handle = venmo_handle;
        this.allow_personal_tips = allow_personal_tips;
        this.tipping_enabled = tipping_enabled;
    }
}
